import { useEffect, useRef } from "react";
import CloseButton from "./CloseButton";

const SettingsPane = ({ onClose }) => {
    const settingsPaneRef = useRef(null);

    useEffect(() => {
        // Ensure the div is focusable
        settingsPaneRef.current.setAttribute('tabIndex', '0');
        // Focus on the div when the component mounts
        settingsPaneRef.current.focus();
    }, []);

    const handleKeyPress = (event) => {
        if (event.key === 'Escape') {
            onClose();
        }
    };

    const lightUnderlineText = (text) => {
        return <span style={{ fontWeight: "lighter", textDecoration: "underline" }}>{text}</span>;
    }

    return (
        <div className="settings-pane" ref={settingsPaneRef} onKeyDown={handleKeyPress}>
            <CloseButton onClose={onClose} />
            <center><h2>How to Play</h2></center>

            <div style={{ padding: "10px", border: "1px solid #ceaa57", background: "rgba(20, 31, 46, 0.8)", boxShadow: "inset 0 0 10px rgba(0,0,0,0.8)", overflowY: "scroll", maxHeight: "50vh" }}>
                <h4>For each cell, select a servant that fits the criteria of that cell's
                    row and column heading.
                </h4>
                <h4>Can use a {lightUnderlineText("Command Spell")} (upto 3 times) to undo any selection (including a wrong selection) or get a hint.</h4>
                <h4>Click on the Category cell to display more info.</h4>
                {/* <h4>{lightUnderlineText("Score")} is based on how unique your selection is
                 vs. other Fate Grid players for the selected cell. Calculated as (100 - p), where p is % of 
                 players selected this servant.</h4>
            <h4 style={{paddingBottom:'0'}}>Raritiy Colours:</h4>
            <div style={{ paddingLeft:"10px",paddingBottom:"10px"}}>
            <h5>🟩 - Common (selected by 20-100% of players)</h5>
            <h5>🟦 - Rare (selected by 10-20%)</h5>
            <h5>🟪 - Epic (selected by 3-10%)</h5>
            <h5>🟧 - Legendary (selected by 0-3%)</h5>
            <h5>🟥 - First (you are first to select this servant for that cell)</h5>
            <h5>⬛ - Wrong Selection</h5>
            <h5>⬜ - Unknown (if unable to connect to server)</h5>
            </div>
            <h4>A servant may be used more than once but doing so will reward {lightUnderlineText("less")} score
            (half of normal).</h4> */}
                <h4>Grid refreshes everyday at midnight (PDT).</h4>
                <h4>Servant Data last updated on 28 Mar, 2024.
                    Contains first ascension arts of all servants released till this date in JP (spoilers?).</h4>
                <h6>V1.4.0</h6>
            </div>
        </div>
    );
}

export default SettingsPane;    